import React, { Component } from 'react';
import {Button, ControlLabel, FormGroup, HelpBlock} from 'react-bootstrap';
import { withRouter } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./ListEditor.css"
import { isUndefined } from 'util';

class ListEditor extends Component {
    constructor(props) {
        super(props);

        const requiredProps = ['createListItem', 'defaultValues', 'setListItems'];
        requiredProps.forEach((requiredPropName) => {
            if (isUndefined(this.props[requiredPropName])) {
                throw new Error("ListEditor was constructed without required prop: " + requiredPropName);
            }
        });
        //const optionalProps = ['addButtonText', 'descriptionText', 'headerText', 'values', 'valuesMaxLength'];

        let values = this.props.defaultValues;
        if (this.props.values) {
            values = this.props.values.map((rQ, index) => {
                return Object.assign({ key: index }, rQ);
            });
        }

        this.state = {
            values: values,
            lastKey: values.length - 1
        };
        this.addListItem = this.addListItem.bind(this);
        this.updateListItem = this.updateListItem.bind(this);
        this.removeListItem = this.removeListItem.bind(this);
    }
    addListItem() {
        var valueArray = this.state.values.slice();
        var lastKey = this.state.lastKey;
        valueArray.push({key: lastKey+1});
        this.setState({
            values: valueArray,
            lastKey: lastKey + 1
        });
        this.props.setListItems(valueArray);
    }
    updateListItem(index, newValue) {
        var valueArray = this.state.values.map((value, valueIndex) => {
            return valueIndex === index ? Object.assign(value, newValue) : value; // Does value need to be cloned?
        });

        this.setState({ values: valueArray });
        this.props.setListItems(valueArray);
    }
    removeListItem(index) {
        var valueArray = this.state.values.slice();
        valueArray.splice(index, 1);

        this.setState({
            values: valueArray
        });
        this.props.setListItems(valueArray);
    }
    render() {
        const self = this;
        const isBelowMax = (this.state.values && this.props.valuesMaxLength) && (this.state.values.length < this.props.valuesMaxLength);
        const isAboveMin = (this.state.values) && (this.state.values.length > (this.props.valuesMinLength ?? 1));
        return (
            <FormGroup className="list-editor-container" controlId="">
                {this.props.headerText && <ControlLabel>{this.props.headerText}</ControlLabel>}
                {this.props.descriptionText &&  <div>{this.props.descriptionText}</div>}
                {
                    this.state.values.map((value, index) => {
                        return (
                            <div className="list-item-container" key={value.key}>
                                <div className="list-item-body">
                                    {
                                        self.props.createListItem({
                                            index: index,
                                            value: value,
                                            updateListItem: this.updateListItem
                                        })
                                    }
                                </div>
                                <div className="list-item-remove">
                                    { isAboveMin &&
                                        <Button bsStyle="link" onClick={() => this.removeListItem(index)}>
                                            <FontAwesomeIcon icon="minus-square"/>
                                        </Button>
                                    }
                                </div>
                            </div>
                        )
                    })
                }
                { isBelowMax && <AddListItemButton buttonText={this.props.addButtonText} addListItem={this.addListItem}/> }
                <HelpBlock className="validation-error has-error">{this.props.validationErrors}</HelpBlock>
            </FormGroup>
        )
    }
}

class AddListItemButton extends Component {
    render() {
        const buttonText = this.props.buttonText || "Add Item";
        return (
            <Button onClick={() => this.props.addListItem()}>
                {buttonText}
            </Button>
        );
    }
}

const ListEditorWithRouter = withRouter(ListEditor);
export default ListEditorWithRouter
